import React from 'react';
import './Card.css';

const Card = ({ id, photo, isFlipped, isMatched, onClick }) => {
  const handleClick = () => {
    if (!isFlipped && !isMatched) {
      onClick();
    }
  };

  const cardBackStyle = {
    backgroundImage: 'url("/photos/nicoleLogo2.png")',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    opacity: 0.8
  };

  return (
    <div 
      className={`card ${isFlipped ? 'flipped' : ''} ${isMatched ? 'matched' : ''}`}
      onClick={handleClick}
      data-card-id={id}
    >
      <div className="card-inner">
        <div className="card-front">
          <img 
            src={photo} 
            alt="Memory card" 
            className="card-img"
            loading="eager"
            decoding="async"
            onError={(e) => {
              console.error('❌ Card image failed to display:', photo);
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="card-fallback" style={{ display: 'none' }}>
            <span>?</span>
          </div>
        </div>
        <div className="card-back">
          <div className="card-back-pattern"></div>
          <div className="card-back-logo" style={cardBackStyle}></div>
        </div>
      </div>
    </div>
  );
};

export default Card; 